import { ThingsLocation } from "./thingsLocation";
import { ThingAccessories } from "./thingAccessories";
import { ThingUserAccess } from "./thingUserAccess";
import { ThingsManufactureDetails } from "./thingsManufactureDetails";
export class Thing {
  id: string;
  macId: string;
  serverId: string;
  action: string;
  thingType: string;
  groupBy: string;
  timeStamp: number;
  buildNumber: number;
  thingsLocation: ThingsLocation;
  roomName: string;
  accessories: Array<ThingAccessories>;
  info: any;
  admins: Array<string>;
  userAccess: Array<ThingUserAccess>;
  isOnline: boolean;
  manufacturerDetails: ThingsManufactureDetails;
  isRegistred: boolean;
  isNewlyAdded: boolean;
  canChangeThingType: boolean;
  isLinkableThing: boolean;
  model: string;
  version: string;
  initialModel: string;
  initialVersion: string;

  constructor(
    id: string,
    macId: string,
    serverId: string,
    action: string,
    thingType: string,
    groupBy: string,
    timeStamp: number,
    buildNumber: number,
    thingsLocation: ThingsLocation,
    roomName: string,
    accessories: Array<ThingAccessories>,
    info: any,
    admins: Array<string>,
    userAccess: Array<ThingUserAccess>,
    isOnline: boolean,
    manufacturerDetails: ThingsManufactureDetails,
    isRegistred: boolean,
    isNewlyAdded: boolean,
    canChangeThingType: boolean,
    isLinkableThing: boolean,
    model: string,
    version: string,
    initialModel: string,
    initialVersion: string
  ) {
    this.macId = macId;
    this.serverId = serverId;
    this.action = action;
    this.thingType = thingType;
    this.groupBy = groupBy;
    this.timeStamp = timeStamp;
    this.buildNumber = buildNumber;
    this.thingsLocation = thingsLocation;
    this.roomName = roomName;
    this.accessories = accessories;
    this.info = info;
    this.admins = admins;
    this.userAccess = userAccess;
    this.isOnline = isOnline;
    this.manufacturerDetails = manufacturerDetails;
    this.isRegistred = isRegistred;
    this.isNewlyAdded = isNewlyAdded;
    this.canChangeThingType = canChangeThingType;
    this.isLinkableThing = isLinkableThing;
    this.model = model;
    this.version = version;
    this.initialModel = initialModel;
    this.initialVersion = initialVersion;
  }
}
